"use client";

import React, { useEffect } from "react";
import { PageWithLayout, ShaSpin } from "@shesha-io/reactjs";
import { useRouter } from "next/navigation";
import { URL_DASHBOARD_PAGE } from "@/routes";

interface IProps {}

/**
 * Landing page. It holds no content of its own, it only sends the user to the
 * right place:
 *  - authenticated users go to the dashboard;
 *  - everyone else is bounced to the login page by the auth guard of the portal
 *    layout, which also appends a returnUrl so they land on the dashboard once
 *    they've logged in.
 *
 * The auth state isn't resolved on this page (the auth guard lives in the portal
 * layout, which this page isn't wrapped in), so the dashboard route is the one
 * that decides whether the user is allowed through.
 */
const Home: PageWithLayout<IProps> = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace(URL_DASHBOARD_PAGE);
  }, [router]);

  return <ShaSpin spinning tip="Redirecting..."><div style={{ height: "100vh" }} /></ShaSpin>;
};

export default Home;
